import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useCurrentUser } from '../hooks/useCurrentUser';
import type { AdminTab } from '../lib/rolePermissions';

interface AdminAuthGateProps {
  children: ReactNode;
  requiredTab: AdminTab;
  redirectTo: string;
}

export default function AdminAuthGate({ children, requiredTab, redirectTo }: AdminAuthGateProps) {
  const { user, loading } = useCurrentUser();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-10 w-10 border-4 border-golf-orange border-t-transparent" />
      </div>
    );
  }

  if (!user || !user.isActive) {
    return <Navigate to={redirectTo} replace />;
  }

  if (!user.allowedTabs.includes(requiredTab)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
